import { useQuery } from '@tanstack/react-query';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { PaymentMethodsResponse } from '../api/types';

const usePaymentMethods = (billingAccountId: number | null) => {
  const enabled = billingAccountId != null;
  const query = useQuery<PaymentMethodsResponse | null>({
    queryKey: enabled
      ? orderV2QueryKeys.paymentMethods(billingAccountId)
      : ['orders_v2', 'payment_methods', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listPaymentMethods(billingAccountId as number)
        .then((result) => result || null),
    enabled,
  });

  return {
    paymentMethods: query.data ?? null,
    paymentMethodsLoading: enabled && query.isFetching,
    paymentMethodsError: query.error
      ? (query.error as Error).message || 'Failed to load payment methods'
      : null,
  };
};

export default usePaymentMethods;
